import { Action } from '@ngrx/store';
import { NotificationData } from '@core/store/models/notifications.interface';
import { NotificationsContextEnum } from '@core/store/models/notifications.enum';
// import { HttpErrorResponse } from '@angular/common/http';
// import { HttpStatus } from '@core/classes/http-status.class';

// import * as Objects from '@core/objects';
// import * as Access from '@app/models/access';

export enum NotificationsActionType {

	// EVENT CALLS
    Add = "[Notifications] - Create new notification",
    Hide = "[Notifications] - Hide notification",
    Clear = "[Notifications] - Clear notifications"
}

// Load Available Events
export class Add implements Action {
    readonly type = NotificationsActionType.Add;
    constructor(public context: NotificationsContextEnum, public data: NotificationData) {}
}

export class Hide implements Action {
    readonly type = NotificationsActionType.Hide;
    constructor(public id: string) {}
}

export class Clear implements Action {
    readonly type = NotificationsActionType.Clear;
    constructor() {}
}

export type NotificationsActions = 	Add |
                                Hide | 
                                Clear
                                ;
